// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2cvAF","itemTitle":"ClientEmergencyInfo_itemTitle__vkHa3","itemText":"ClientEmergencyInfo_itemText__2VR5t"};